import { Outlet, Link } from 'react-router-dom';
import Navbar from './Navbar';
import { ToastContainer } from '@/components/common';
import Footer from '@/components/layout/Footer';
import FloatingToolbar from './FloatingToolbar';
import { useState } from 'react';

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col relative w-full max-w-full overflow-x-hidden" style={{ background: 'var(--surface-1)' }}>
      <Navbar />
      <main className="flex-1 w-full max-w-full pt-14 md:pt-[104px]">
        <div className="max-w-[1280px] mx-auto px-4 py-6">
          <Outlet />
        </div>
      </main>
      <Footer />
      <FloatingToolbar />
      <ToastContainer />
    </div>
  );
}
